const Colors = {
    gray: '#606060',
    white: '#FFFFFF',
    primary: '#0E512E',
    whitesmoke: '#f5f5f5',
    appbarBorder: '#707070',
    tabBorder: '#EBEBEB',
    tabSurface: '#F7F7F7',
    brown: '6F6F6F',
    tabUnselected: '#868686',
};

export default Colors;